<template>
	<div>
		<div class="message-text text-dark fw-bold mw-lg-400px fs-14px rounded p-5">
            <div class="mb-4 d-flex align-items-center">
                <i class="bi bi-geo-alt me-2 fs-1"></i>
                <span class="fs-5" >
                    {{ $t("location") }}
                </span>
            </div>
			<img
				:src="loadFile('map-placeholder.svg')"
				style="width: 200px; cursor: pointer"
				@click="onClick"
			/>
		</div>
	</div>
</template>

<script setup>
import { loadFile } from '../../../utils';
const props = defineProps({
	message: Object,
});

const openLocation = ({ latitude, longitude }) => {
	const zoom = 15;
	window.open(`https://www.google.com/maps/@${latitude},${longitude},${zoom}z?entry=ttu`);
};

const onClick = () => {
	openLocation({
		latitude: props.message.content.latitude,
		longitude: props.message.content.longitude,
	});
};
</script>

<style lang="scss" scoped>
@import './styles/chat.scss';

.text-link {
	cursor: pointer;
}
.text-link:hover {
	text-decoration: underline;
}
</style>
